export const vieIntakeFormConfig = {
  metadata: {
    title: "Intakeformulier Energiecontract",
    subtitle: "VIE \u2013 Verbindingen Integratie & Educatie",
    defDossier: 6654,
    environment: 398,
    brandColors: {
      primary: "#003366",
      primaryDark: "#002244",
      primaryLight: "#004488",
      accent: "#1abc9c",
      accentLight: "#2ed8b6",
      success: "#1abc9c",
      neutral: "#f8f9fa",
      text: "#1f2d3d",
      textLight: "#4e5d6c",
      border: "#e9ecef",
    },
  },

  sections: [
    {
      id: "naw-gegevens",
      title: "Naw-gegevens",
      order: 1,
      layout: {
        columns: { default: 1, md: 2 },
        gap: "gap-4",
      },
      fields: [
        {
          id: "postcode",
          name: "136778",
          type: "text",
          label: "Postcode",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "huisnummer",
          name: "136779",
          type: "text",
          label: "Huisnummer",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "toevoeging",
          name: "136780",
          type: "text",
          label: "Toevoeging Huisnummer",
          required: false,
          columnSpan: { default: 1 },
          validation: {},
        },
        {
          id: "straatnaam",
          name: "136781",
          type: "text",
          label: "Straatnaam",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "woonplaats",
          name: "136782",
          type: "text",
          label: "Woonplaats",
          required: true,
          columnSpan: { default: 1, md: 2 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "bestaande-klant",
          name: "136797",
          type: "radio-group",
          label: "Betreft het een bestaande klant?",
          required: true,
          columnSpan: { default: 1, md: 2 },
          options: [
            { value: "69042", label: "Ja" },
            { value: "69043", label: "Nee" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
      ],
    },
    {
      id: "verbruik",
      title: "Verbruik",
      order: 2,
      layout: {
        columns: { default: 1 },
        gap: "gap-4",
      },
      fields: [
        {
          id: "type-energie",
          name: "136735",
          type: "radio-group",
          label: "Welke type Energie: Stroom & gas of Stroom?",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "69030", label: "Gas + elektriciteit" },
            { value: "69031", label: "Alleen elektriciteit" },
            { value: "69032", label: "Alleen gas" },
            { value: "69033", label: "Stadsverwarming + elektriciteit" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "personen",
          name: "136736",
          type: "number",
          label: "Hoeveel personen heeft het huishouden?",
          required: false,
          columnSpan: { default: 1 },
          validation: {},
        },
        {
          id: "type-woning",
          name: "136737",
          type: "radio-group",
          label: "Type Woning",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "69039", label: "Appartement" },
            { value: "69038", label: "Rijtjeshuis" },
            { value: "69037", label: "Hoekwoning" },
            { value: "69036", label: "Vrijstaand" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "slimme-meter",
          name: "136739",
          type: "radio-group",
          label: "Is er een slimme meter aanwezig?",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "69034", label: "Ja" },
            { value: "69035", label: "Nee" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "meter-readings",
          name: "136806",
          type: "textarea",
          label: "Meter readings",
          required: false,
          columnSpan: { default: 1 },
          conditionalOn: { field: "136739", value: "69035" },
          validation: {},
        },
      ],
    },
    {
      id: "contract",
      title: "Contract",
      order: 3,
      layout: {
        columns: { default: 1 },
        gap: "gap-4",
      },
      fields: [
        {
          id: "contract-termijn",
          name: "136738",
          type: "radio-group",
          label: "Contract termijn: 1 ?",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "69041", label: "1 jaar" },
            { value: "69040", label: "3 jaar" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "ingangsdatum",
          name: "136740",
          type: "date",
          label: "Gewenste ingangsdatum?",
          required: true,
          columnSpan: { default: 1 },
          dateLimit: { type: "after", date: new Date().toISOString().split("T")[0] },
          validation: { required: "Dit is een verplicht veld" },
        },
      ],
    },
    {
      id: "contact-gegevens",
      title: "Contact gegevens",
      order: 4,
      layout: {
        columns: { default: 1, md: 2 },
        gap: "gap-4",
      },
      fields: [
        {
          id: "aanhef",
          name: "137171",
          type: "radio-group",
          label: "Aanhef",
          required: true,
          columnSpan: { default: 1, md: 2 },
          options: [
            { value: "69044", label: "De heer" },
            { value: "69045", label: "Mevrouw" },
            { value: "69046", label: "Anders" },
            { value: "69047", label: "Zeg ik liever niet" },
          ],
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "voornaam",
          name: "137170",
          type: "text",
          label: "Voornaam",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "achternaam",
          name: "137169",
          type: "text",
          label: "Achternaam",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "geboortedatum",
          name: "137168",
          type: "date",
          label: "Geboortedatum",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "email",
          name: "137167",
          type: "email",
          label: "E-mail",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit is een verplicht veld",
            pattern: { value: /^\S+@\S+$/i, message: "Ongeldig e-mailadres" },
          },
        },
        {
          id: "telefoonnummer",
          name: "137166",
          type: "text",
          label: "Telefoonnummer",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "iban-tenaamstelling",
          name: "137165",
          type: "text",
          label: "Tenaamstelling IBAN",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Dit is een verplicht veld" },
        },
        {
          id: "iban-nummer",
          name: "137164",
          type: "text",
          label: "IBAN rekeningnummer",
          required: true,
          columnSpan: { default: 1, md: 2 },
          validation: { required: "Dit is een verplicht veld" },
        },
      ],
    },
    {
      id: "volmacht",
      title: "Volmacht",
      order: 5,
      layout: {
        columns: { default: 1 },
        gap: "gap-4",
      },
      sectionContent: {
        title: "",
        body: [
          "Ondergetekende verleent hierbij een <strong>volmacht</strong> aan <strong>VIE</strong> om namens hem/haar alle handelingen te verrichten die noodzakelijk zijn voor het aanvragen, afsluiten en beheren van een energiecontract.",
          "Deze volmacht omvat onder meer, maar niet uitsluitend:",
        ],
        sections: [
          {
            title: "Aanvraag en afsluiting",
            items: [
              "Het opvragen, vergelijken en aanvragen van energiecontracten.",
              "Het afsluiten van een nieuw energiecontract bij een energieleverancier naar keuze van VIE, binnen de door ondergetekende aangegeven voorwaarden.",
            ],
          },
          {
            title: "Beheer van het contract",
            items: [
              "Het doorgeven en wijzigen van persoonsgegevens, contactgegevens en verbruiksgegevens aan de energieleverancier.",
              "Het opvragen van contractinformatie, verbruiksgegevens, kostenoverzichten en overige relevante documentatie.",
              "Het uitvoeren van administratieve wijzigingen zoals voorschotaanpassingen, adreswijzigingen of bankgegevens.",
              "Het communiceren met de energieleverancier over storingen, klachten, facturen, betalingen en overige contractuele aangelegenheden.",
              "Het opzeggen van het huidige energiecontract en het verzorgen van eventuele overstappen, indien dit noodzakelijk of wenselijk is.",
            ],
          },
          {
            title: "Duur van de volmacht",
            items: [
              "Deze volmacht blijft geldig totdat ondergetekende deze schriftelijk intrekt.",
            ],
          }
        ],
        footer: [
          "Indien u de dienstverlening wilt opzeggen, kan dat telefonisch via het volgende nummer: 06 420 460 11, of per e-mail via info@ondersteuningv.nl.tekst"
        ]
      },
      fields: [
        {
          id: "handtekening",
          name: "136807",
          type: "signature",
          label: "Handtekening",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "Handtekening is verplicht" },
        },
        {
          id: "datum-volmacht",
          name: "137163",
          type: "date",
          label: "Datum",
          required: true,
          columnSpan: { default: 1 },
          dateLimit: { type: "after", date: new Date().toISOString().split("T")[0] },
          validation: { required: "Dit is een verplicht veld" },
        },
      ],
    },
  ],

  progress: {
    enabled: false,
    trackRequiredFields: false,
  },

  autoSave: {
    enabled: false,
  },

  submission: {
    submitButton: {
      text: "Verzenden",
      requireAllRequired: true,
    },
  },

  styling: {
    fonts: {
      primary: "Arial, sans-serif",
      size: { small: "12px", base: "14px", large: "16px" },
    },
    spacing: { small: "8px", base: "12px", medium: "16px", large: "24px" },
    borderRadius: { small: "6px", base: "6px", large: "10px" },
    shadows: {
      small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      medium: "0 4px 12px rgba(0, 0, 0, 0.08)",
      large: "0 4px 12px rgba(0, 0, 0, 0.08)",
    },
    transitions: {
      fast: "all 0.2s ease-in-out",
      medium: "all 0.3s ease-out",
    },
    index: {
      width: "28px",
      height: "28px",
      fontSize: "14px",
    },
    title: {
      fontWeight: 600,
      fontSize: "1.15em",
    },
    label: {
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "1.4",
      marginTop: "0",
      marginBottom: "6px",
      textAlign: "left",
      color: "#1f2d3d",
      fontFamily: "Arial, sans-serif",
    },
    input: {
      display: "block",
      padding: "10px 12px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.5",
      backgroundColor: "#fff",
      border: "1px solid #ced4da",
      borderRadius: "6px",
      transition: "all 0.2s ease-in-out",
      fontFamily: "Arial, sans-serif",
    },
    checkbox: {
      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.25",
      border: "none",
      height: "26px",
      borderRadius: "6px",
      boxShadow: "none",
    },
    radio: {
      display: "flex",
      gap: "12px",
      cursor: "pointer",
      marginBottom: "0.5rem"
    },

    radioButton: {


      accentColor: "#003366",
    },

    textarea: {
      height: "120px",
      resize: "vertical",
      minHeight: "100px",
    },
    select: {
      control: {
        border: "1px solid #ced4da",
        borderRadius: "6px",
        minHeight: "42px",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
      },
      placeholder: { color: "#6b7280" },
      valueContainer: { padding: "2px 12px" },
    },
    button: {
      background: "#1abc9c",
      color: "white",
      fontWeight: "600",
      padding: "11px 28px",
      borderRadius: "6px",
      border: "none",
      fontSize: "1rem",
      transition: "opacity 0.2s ease-in-out",
    },
  },
};

export default vieIntakeFormConfig;
